import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import BookingUser from './booking-user';
import BookingUserDetail from './booking-user-detail';
import BookingUserUpdate from './booking-user-update';
import BookingUserDeleteDialog from './booking-user-delete-dialog';

const BookingUserRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<BookingUser />} />
    <Route path="new" element={<BookingUserUpdate />} />
    <Route path=":id">
      <Route index element={<BookingUserDetail />} />
      <Route path="edit" element={<BookingUserUpdate />} />
      <Route path="delete" element={<BookingUserDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default BookingUserRoutes;
